module.exports = __webpack_public_path__ + "img/avatardemo.6f0bd031.jpg";